import {handleActions} from 'redux-actions';

import {loadFilterTransactionsSuccess} from '../../../actions/entities/transactions';
import {signOutSuccess} from '../../../actions/User';
import EntityMap from '../../../entities/EntityMap';

const initialState = EntityMap.fromArray([]);

export default handleActions(
  {
    [loadFilterTransactionsSuccess]: (state, action) => {
      const transactions = action.payload;
      return EntityMap.fromArray(transactions);
    },
    [signOutSuccess]: () => initialState
  },
  initialState
);
